import { useParams } from 'react-router-dom'
import { Box, Heading, Text } from '@chakra-ui/react'
import { getResourceConfig } from '@/modules/admin/schema'
import AdminResourcePage from '@/modules/admin/AdminResourcePage'

export default function AdminResourceRoute() {
    const { resource } = useParams<{ resource: string }>()
    const config = getResourceConfig(String(resource))

    if (!config) {
        return (
            <Box>
                <Heading size="md">Unknown content type</Heading>
                <Text color="gray.600">
                    “{String(resource)}” is not a valid resource.
                </Text>
            </Box>
        )
    }

    return <AdminResourcePage config={config} />
}
